import { assertIsIconDoc, assertIsItemAttachmentDoc, type IconDoc, type ItemAttachmentDoc } from "../common/schema";
import { type Documentish } from "./image_attachments";
import { assert } from "./utils";

export type ExistingItemAttachmentDoc = ItemAttachmentDoc & Documentish & PouchDB.Core.ExistingDocument<{}>;
export type ExistingIconDoc = IconDoc & Documentish & PouchDB.Core.ExistingDocument<{}>;

export function assertIsExistingIconDoc(val: unknown): asserts val is ExistingIconDoc {
  assertIsIconDoc(val);
  assert(typeof val._rev === 'string', 'icon doc missing _rev');
}

export function assertIsExistingItemAttachmentDoc(val: unknown): asserts val is ExistingItemAttachmentDoc {
  assertIsItemAttachmentDoc(val);
  assert(typeof val._rev === 'string', 'attachment doc missing _rev');
}
